























import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { DateTime } from 'luxon';
@Component
export default class UIDatePicker extends Vue {
  @Prop() readonly value: string;
  @Prop() readonly label: string;
  menu: boolean = false;
  dateString = this.value ? this.date : '';
  // @ts-ignore
  get date() {
    if (this.value) return DateTime.fromSQL(this.value).toLocaleString();
  }
  set date(value: string) {
    this.$emit(
      'change',
      DateTime.fromFormat(value, 'dd.L.yyyy').toSQL({ includeOffset: false }),
    );
  }
  get pickerDate() {
    if (this.date) {
      return DateTime.fromFormat(this.date, 'dd.L.yyyy')
        .toString()
        .substr(0, 10);
    }
    else {
      return DateTime.local()
        .toString()
        .substr(0, 10);
    }
  }
  set pickerDate(value) {
    this.$emit(
      'change',
      DateTime.fromFormat(value, 'yyyy-L-dd').toSQL({ includeOffset: false }),
    );
  }
  @Watch('date')
  updateDateString(val: string) {
    this.dateString = val;
  }
}
